module.exports = __webpack_public_path__ + "static/img/0546_9.b631906.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0546_9.jpg
// module id = mZ0H
// module chunks = 1